import type { CompanyDocumentType } from './Common';
import { CompanyMemberAccess } from './CompanyMemberAccesses';
import type { WarehouseMemberAccess } from './WarehouseMemberAccesses';
export interface Company {
  id: number;
  documentType: CompanyDocumentType;
  tradeName: string;
  document: string;
}

export type UserType =
  | 'admin'
  | 'companyMember'
  | 'carrierMember'
  | 'warehouseMember'
  | 'checklistMember'
  | 'ymsPortariaMember';

export const YMS_PORTARIA_MEMBER_TYPE = 'ymsPortariaMember';

export interface Carrier extends Company {}

export interface Warehouse extends Company {}

export interface AuthData {
  profile: {
    userId: number;
    type: UserType;
    email: string;
    name: string;
    company?: Company;
    allowToday?: 1 | 0 | null;
    companyAccess?: CompanyMemberAccess[];
    carrier?: Carrier;
    warehouse?: Warehouse;
    warehouseAccess?: WarehouseMemberAccess[];
    root?: boolean;
    portariaRoles?: Array<{ code: string; name: string }>;
  };
  token: string;
}
